import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { validateAttributes, errorMessage } from "../utils/validations";
import { sectionValidations } from "./validations";

const SectionForm = (props) => {
  const { sections, setSections, section, courseId, setSelectedSection } =
    props;
  const [title, setTitle] = useState(section ? section.title : "");
  const [description, setDescription] = useState(
    section ? section.description : "",
  );

  const [errors, setErrors] = useState({});

  const postSection = async () => {
    const response = await fetch(`/courses/${courseId}/sections`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content,
      },
      body: JSON.stringify({
        section: {
          title: title,
          description: description,
        },
      }),
    });
    if (response.ok) {
      const data = await response.json();
      setSections([...sections, ...[data.section]]);
      setSelectedSection(data.section);
    } else {
      // TODO handle error messages
      console.log("ERROR");
    }
  };

  const patchSection = async () => {
    const response = await fetch(
      `/courses/${courseId}/sections/${section.id}`,
      {
        method: "PATCH",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content,
        },
        body: JSON.stringify({
          section: {
            title: title,
            description: description,
          },
        }),
      },
    );
    if (response.ok) {
      const data = await response.json();
      setSections(
        sections.map((updatedSection) =>
          updatedSection.id == section.id ? data.section : updatedSection,
        ),
      );
    } else {
      console.log("ERROR");
    }
  };

  useEffect(() => {
    setTitle(section ? section.title : "");
    setDescription(section ? section.description : "");
  }, [section]);

  const handleSubmit = async () => {
    const validation = validateAttributes(
      {
        title,
      },
      sectionValidations,
    );

    setErrors(validation);

    if (validation) return;

    if (section) {
      await patchSection();
    } else {
      await postSection();
    }
  };

  const className = (attribute) => {
    let className = "w-full mt-1 border px-3 py-2 text-sm";
    if (errors && errors[attribute]) {
      className += " border border-red-500 focus:ring-red-500";
    }
    return className;
  };

  return (
    <div className="w-full max-w-md p-6 flex flex-col gap-2">
      <div>
        <label className="block text-sm font-medium text-black mb-1">
          Tytuł
        </label>
        <input
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          className={className("title")}
          placeholder="Tytuł"
        />
        {errorMessage(errors, "title")}
      </div>

      <div>
        <label className="block text-sm font-medium text-black mb-1">
          Opis (opcjonalnie)
        </label>
        <input
          type="text"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          className="w-full mt-1 border px-3 py-2 text-sm"
          placeholder="Opis..."
        />
      </div>

      <button
        type="submit"
        className="gap-2 bg-black text-white px-4 py-2 w-24 mt-10 ml-auto"
        onClick={handleSubmit}
      >
        Zapisz
      </button>
    </div>
  );
};

SectionForm.propTypes = {
  sections: PropTypes.array,
  setSections: PropTypes.func,
  setSelectedSection: PropTypes.func,
  courseId: PropTypes.string,
  section:
    PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
      description: PropTypes.string,
      lessons: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          title: PropTypes.string,
          description: PropTypes.string,
        }),
      ),
    }) || undefined,
};

export default SectionForm;
